import React from "react";

/**
 * Renders a down arrow SVG icon with the given class.
 *
 * @param {string} cls - The class name for the SVG icon
 * @return {JSX.Element} The down arrow SVG icon
 */
export const DownArrowIcon = ({ cls }) => {
  return (
    <svg
      className={cls}
      width="16"
      height="10"
      viewBox="0 0 16 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M15.787 0.849224C15.503 0.565249 15.0425 0.5652 14.7585 0.849273L8.00017 7.60772L1.24153 0.849224C0.957552 0.565249 0.497042 0.5652 0.213018 0.849273C-0.0710061 1.1333 -0.0710061 1.59376 0.213018 1.87778L7.48594 9.15051C7.62233 9.2869 7.8073 9.3635 8.00017 9.3635C8.19304 9.3635 8.37806 9.28685 8.5144 9.15046L15.7869 1.87773C16.071 1.59376 16.071 1.13325 15.787 0.849224Z"
        fill="currentColor"
      />
    </svg>
  );
};
